// src/features/dashboard/utils/buildPaceInsights.js
import { fmtAUD } from '@/shared/utils/formatCurrency';

export function buildPaceInsights(monthTxns, selMonth, selYear, incomeList, expByGroup, currentBudgets, expenseMap) {
  const today = new Date();
  if (selMonth !== today.getUTCMonth() || selYear !== today.getUTCFullYear()) return [];

  const daysInMonth = new Date(Date.UTC(selYear, selMonth + 1, 0)).getUTCDate();
  const daysElapsed = today.getUTCDate();
  const daysLeft = daysInMonth - daysElapsed;

  if (daysElapsed < 5) return [];

  const insights = [];

  const monthExpenses = (monthTxns || [])
    .filter(t => !(incomeList || []).includes(t.category))
    .reduce((s, t) => s + (Number(t.amount) || 0), 0);

  const totalBudget = Object.entries(expenseMap || {}).reduce((s, [, cats]) => {
    return s + (cats || []).reduce((cs, c) => cs + (Number((currentBudgets || {})[c]) || 0), 0);
  }, 0);

  if (monthExpenses > 0) {
    const projected = (monthExpenses / daysElapsed) * daysInMonth;
    if (totalBudget > 0 && projected > totalBudget * 1.05) {
      insights.push({
        icon: '⏱️',
        color: '#f59e0b',
        text: 'On pace to spend $' + fmtAUD(projected) + ' by month-end (budget: $' + fmtAUD(totalBudget) + ')',
      });
    }
  }

  if (daysLeft > 0) {
    const alerts = Object.entries(expenseMap || {}).flatMap(([group, cats]) => {
      const groupBudget = (cats || []).reduce((s, c) => s + (Number((currentBudgets || {})[c]) || 0), 0);
      if (groupBudget <= 0) return [];
      const spent = Number((expByGroup || {})[group]) || 0;
      const remaining = groupBudget - spent;
      if (remaining <= 0) return [];
      const perDay = remaining / daysLeft;
      if (perDay >= 10) return [];
      return [{ group, perDay, spent, groupBudget }];
    });

    if (alerts.length > 0) {
      alerts.sort((a, b) => a.perDay - b.perDay);
      const worst = alerts[0];
      insights.push({
        icon: '📅',
        color: '#f59e0b',
        text:
          String(worst.group) + ' has $' + fmtAUD(worst.perDay) + '/day left for ' +
          daysLeft + ' more day' + (daysLeft === 1 ? '' : 's') +
          ' ($' + fmtAUD(worst.spent) + ' of $' + fmtAUD(worst.groupBudget) + ' budget used)',
      });
    }
  }

  return insights;
}
